<app-lms-modal-frame [title]="'Product Setup'" [pageHeadWidth]="740">
  <div modal-body>
    <div class="card">
      <div class="card-body p-1">
        <div class="center-screen container-fluid bd-example-row">
          <form [formGroup]="addLoanTypeForm" novalidate>
              <div>
                <table id="productRates" class="table p-1 table-striped table-hover table-sm mb-3 caption-top shadow-1-strong rounded-1" [style.width.px]="900">
                  <thead class="table-center-header">
                    <tr>
                      <td colspan="4">Product Details</td>
                    </tr>
                  </thead>
                  <tbody class="field-4column-label">
                    <tr>
                      <td><label for="code">Code</label></td>
                      <td>
                      <input type="text" formControlName="code" [(ngModel)]="ratesAndFeesModel.code">
                      </td>

                      <td><label for="description">Description</label></td>
                      <td>
                        <input type="text" formControlName="description" [(ngModel)]="ratesAndFeesModel.description"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.description.errors?.required && submitted" class="error-label">
                          Description is required
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Minimum Loan Amount</td>
                      <td>
                        <input type="text" formControlName="minimumLoan" [(ngModel)]="ratesAndFeesModel.minimumLoan"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.minimumLoan.errors?.required && submitted" class="error-label">
                          Minimum loan is required
                        </div>
                      </td>

                      <td>Maximum Loan Amount</td>
                      <td>
                        <input type="text" formControlName="maximumLoan" [(ngModel)]="ratesAndFeesModel.maximumLoan"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.maximumLoan.errors?.required && submitted" class="error-label">
                          Maximum Loan is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Interest rate 1st loan (%)</td>
                      <td>
                        <input type="text" formControlName="interestRate1st"
                          [(ngModel)]="ratesAndFeesModel.interestRate1st" required>
                        <div *ngIf="validateRatesAndFeesValues.interestRate1st.errors?.required && submitted" class="error-label">
                          Interest rate 1st loan is required
                        </div>
                      </td>

                      <td>Interest rate other loans (%)</td>
                      <td>
                        <input type="text" formControlName="interestRateOther"
                          [(ngModel)]="ratesAndFeesModel.interestRateOther" required>
                        <div *ngIf="validateRatesAndFeesValues.interestRateOther.errors?.required && submitted"
                          class="error-label">
                          Interest rate other is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Initiation fee if cap below 1000</td>
                      <td>
                        <input type="text" formControlName="initFeeBelow1000"
                          [(ngModel)]="ratesAndFeesModel.initFeeBelow1000">
                      </td>

                      <td>Initiation fee first 1000</td>
                      <td>
                        <input type="text" formControlName="initFeeFirst1000"
                          [(ngModel)]="ratesAndFeesModel.initFeeFirst1000">
                      </td>
                    </tr>

                    <tr>
                      <td>Initiation fee (%)</td>
                      <td>
                        <input type="text" formControlName="initiationFee" [(ngModel)]="ratesAndFeesModel.initiationFee"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.initiationFee.errors?.required && submitted" class="error-label">
                          Initiation fee is required
                        </div>
                      </td>

                      <td>Initiation fee cap</td>
                      <td>
                        <input type="text" formControlName="initiationCap" [(ngModel)]="ratesAndFeesModel.initiationCap"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.initiationCap.errors?.required && submitted" class="error-label">
                          Initiation fee cap is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>My Benefits (%)</td>
                      <td>
                        <input type="text" formControlName="myBenefits" [(ngModel)]="ratesAndFeesModel.myBenefits"
                          required>
                        <div *ngIf="validateRatesAndFeesValues.myBenefits.errors?.required && submitted" class="error-label">
                          My Benefits is required
                        </div>
                      </td>

                      <td>Term in months</td>
                      <td>
                        <input type="text" formControlName="term" [(ngModel)]="ratesAndFeesModel.term" required>
                        <div *ngIf="validateRatesAndFeesValues.term.errors?.required && submitted" class="error-label">
                          Term is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Factor 1st loan</td>
                      <td>
                        <input type="text" formControlName="factor1stLoan"
                          [(ngModel)]="ratesAndFeesModel.factor1stLoan">
                      </td>

                      <td>Factor other loans</td>
                      <td>
                        <input type="text" formControlName="factorOtherLoan"
                          [(ngModel)]="ratesAndFeesModel.factorOtherLoan">
                      </td>
                    </tr>

                    <tr>
                      <td>Factor up to 850</td>
                      <td>
                        <input type="text" formControlName="factorUpTo850"
                          [(ngModel)]="ratesAndFeesModel.factorUpTo850">
                      </td>

                      <td>Factor up to 1000</td>
                      <td>
                        <input type="text" formControlName="factorUpTo1000"
                          [(ngModel)]="ratesAndFeesModel.factorUpTo1000">
                      </td>
                    </tr>

                    <tr>
                      <td>Monthly service fee</td>
                      <td>
                        <input type="text" formControlName="monthlyServiceFee"
                          [(ngModel)]="ratesAndFeesModel.monthlyServiceFee" required>
                        <div *ngIf="validateRatesAndFeesValues.monthlyServiceFee.errors?.required && submitted"
                          class="error-label">
                          Monthly service fee is required
                        </div>
                      </td>

                      <td>Initiation service fee cap (%)</td>
                      <td>
                        <input type="text" formControlName="initServiceFeeCap"
                          [(ngModel)]="ratesAndFeesModel.initServiceFeeCap" required>
                        <div *ngIf="validateRatesAndFeesValues.initServiceFeeCap.errors?.required && submitted"
                          class="error-label">
                          Initiation service fee cap is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Max days before first payment</td>
                      <td>
                        <input formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                        <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                          Max days before first payment is required
                        </div>
                      </td>
                      <td>Regulatory type</td>
                      <td>
                        <mdb-select class="select table-control has-cell-control" formControlName="regulatoryType" [(ngModel)]="ratesAndFeesModel.regulatoryType" required>
                          <mdb-option *ngFor="let regType of lstRegulatory;" [value]="regType.value">
                            {{regType.description}}
                          </mdb-option>
                        </mdb-select>
                        <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted" class="error-label">
                          Regulatory type is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>MyBenefits Document tier</td>
                      <td>
                        <mdb-select class="select table-control" formControlName="mybenefitsTier" [(ngModel)]="ratesAndFeesModel.mybenefitsTier"
                        required aria-role="listbox">
                        <mdb-option *ngFor="let myben of lstmyBenTier;" [value]="myben.value">
                            {{myben.description}}
                          </mdb-option>
                        </mdb-select>
                        <div *ngIf="validateRatesAndFeesValues.mybenefitsTier.errors?.required && submitted" class="error-label">
                          MyBenefits document tier is required
                        </div>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
              <!-- Product Fee calculations -->
              <div>
                <table id="serviceFees" class="table p-1 table-striped table-hover table-sm mb-3 caption-top shadow-1-strong rounded-1" [style.width.px]="900">
                  <thead class="table-center-header">
                    <tr>
                      <td colspan="4">Product Fee Calculations</td>
                    </tr>
                  </thead>
                  <tbody class="field-4column-label">
                    <tr>
                      <td>Loan Type</td>
                      <td>
                        <input style="width: 250px;" formControlName="type" [(ngModel)]="ratesAndFeesModel.type">
                        <div *ngIf="validateRatesAndFeesValues.calculationType.errors?.required && submitted" class="error-label">
                          Loan type is required
                        </div>
                      </td>

                      <td>Regulatory type</td>
                      <td>
                        <input style="width: 250px;" formControlName="regulatoryType"
                          [(ngModel)]="ratesAndFeesModel.regulatoryType">
                        <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted" class="error-label">
                          Regulatory type is required
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Max days before first payment</td>
                      <td>
                        <input style="width: 250px;" formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                        <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                          Max days before first payment is required
                        </div>
                      </td>

                      <td>Calculation type</td>
                      <td>
                        <input style="width: 250px;" formControlName="calculationType"
                          [(ngModel)]="ratesAndFeesModel.calculationType">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


          </form>
        </div>
      </div>
    </div>
  </div>

  <div modal-actions class="card-footer center-screen py-3">
    <button class="me-2" mdbRipple color="primary" type="button" (click)="close()">Close</button>
    <button class="me-2" mdbRipple color="primary" type="button" (click)="saveLoanType()">Save Product</button>
  </div>
</app-lms-modal-frame>
